import React, { createContext, useState, useContext, ReactNode } from "react";
import { UsersService } from "../../../services/user/users";
import { useAppContext } from "../../../AppProvider";
import { callSuccessToast, callErrorToast } from "../../../utilities/utilities";

const usersService = new UsersService();

interface SendInvitationMailProviderProps {
  id: string;
  children: ReactNode;
  callback?: () => void;
}

interface SendInvitationMailContextValue {
  loader: boolean;
  callback?: () => void;
  sendInvitationMail: () => void;
}

const SendInvitationMailContext = createContext<
  SendInvitationMailContextValue | undefined
>(undefined);

const SendInvitationMailProvider: React.FC<SendInvitationMailProviderProps> = ({
  id,
  children,
  callback,
}) => {
  const { dictionary } = useAppContext();
  const [loader, setLoader] = useState<boolean>(false);

  const sendInvitationMail = (): void => {
    if (!id) {
      return;
    }

    setLoader(true);
    usersService
      .sendInvitationMail(id)
      .then(() => {
        callSuccessToast(dictionary.messages.email_sent_successfully);
        setLoader(false);
        if (callback) callback();
      })
      .catch((err) => {
        callErrorToast(err);
        setLoader(false);
      });
  };

  return (
    <SendInvitationMailContext.Provider
      value={{
        loader,
        sendInvitationMail,
        callback,
      }}
    >
      {children}
    </SendInvitationMailContext.Provider>
  );
};

const useSendInvitationMailContext = (): SendInvitationMailContextValue => {
  const context = useContext(SendInvitationMailContext);
  if (!context) {
    throw new Error("useHandlerContext must be used within a HandlerProvider");
  }
  return context;
};

export { SendInvitationMailProvider, useSendInvitationMailContext };
